import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

// Demande, une seule fois, à la toute première utilisation d'une nouvelle
// ferme : "avez-vous déjà une ferme en activité ?" — pour orienter soit
// vers le rattrapage d'un projet déjà en cours, soit vers un démarrage
// classique à zéro. Ne s'affiche jamais pour les fermes déjà existantes
// (dispensées automatiquement à la migration), ni pour les techniciens/
// investisseurs (seul le gestionnaire répond à cette question).
const ChoixDemarrageGate = ({ children }) => {
  const { utilisateur } = useAuth();
  const [statut, setStatut] = useState(null);
  const [envoi, setEnvoi] = useState(false);
  const navigate = useNavigate();

  const estGestionnaire = utilisateur?.role === 'gestionnaire' || utilisateur?.role === 'gestion_invest';

  useEffect(() => {
    if (!estGestionnaire) {
      setStatut({ demarrage_configure: true });
      return;
    }
    api.get('/organisations/mon-statut-demarrage')
      .then(res => setStatut(res.data))
      .catch(() => setStatut({ demarrage_configure: true }));
  }, [estGestionnaire]);

  const choisir = async (aDejaUneFerme) => {
    setEnvoi(true);
    try {
      await api.post('/organisations/marquer-demarrage-configure');
      setStatut({ demarrage_configure: true });
      if (aDejaUneFerme) {
        navigate('/rattrapage-ferme');
      }
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setEnvoi(false);
    }
  };

  if (statut === null) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-400 text-sm">Chargement...</div>
      </div>
    );
  }

  if (statut.demarrage_configure) {
    return children;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center px-6">
      <div className="max-w-md mx-auto w-full">
        <h1 className="text-lg font-medium text-gray-900 mb-2">Bienvenue 👋</h1>
        <p className="text-sm text-gray-600 mb-6">
          Avez-vous déjà une ferme en activité, avec des productions en cours (pas encore sur cette plateforme) ?
        </p>

        <button onClick={() => choisir(true)} disabled={envoi}
          className="w-full bg-white border border-gray-200 rounded-xl p-4 text-left mb-3 disabled:opacity-50">
          <p className="text-sm font-medium text-gray-900">Oui, j'ai déjà une ferme en activité</p>
          <p className="text-xs text-gray-400 mt-0.5">On rattrape votre état actuel — effectifs, dépenses, caisse — sans tout ressaisir en détail.</p>
        </button>

        <button onClick={() => choisir(false)} disabled={envoi}
          className="w-full bg-white border border-gray-200 rounded-xl p-4 text-left disabled:opacity-50">
          <p className="text-sm font-medium text-gray-900">Non, je démarre une nouvelle ferme à zéro</p>
          <p className="text-xs text-gray-400 mt-0.5">Vous créerez votre premier projet quand vous serez prêt.</p>
        </button>
      </div>
    </div>
  );
};

export default ChoixDemarrageGate;